import React, { useEffect, useState } from "react";
import { Container } from "@mui/material";
import { notification } from "../../utils/Notifications.js";
import { getGuidesInBatch } from "../../api/guidesApi.js";
import Title from "../../components/SharedComponents/Title/index.js";
import SearchBar from "../../components/SharedComponents/SearchBar/index.js";
import useLogout from '../../hooks/auth/authHook.js';
import styles from './guidesDetailsStyles.js';
import GuidesDetailsTable from "../../components/GuidesDetails/GuidesTable/index.js";
import { useParams } from "react-router-dom";

const GuidesDetails = () => {
  const [logout] = useLogout();

  const { id } = useParams();

  const [guides, setGuides] = useState([]);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const fetchGuides = () => {
    setIsLoading(true);
    getGuidesInBatch(Number(id ? id : 0))
      .then((response) => {
        if (response.data.status_Code === 200) {
          setGuides(response.data.guides);
        } else if (response.data.status_Code === 401) {
          notification({
            text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
            type: "error",
          });
          logout();
        } else {
          notification({
            text: "Error al obtener las guías",
            type: "error",
          });
        }
      })
      .catch(() => {
        notification({ text: 'Error de conexión, revisa tu conexión a internet', type: 'error' });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  
  useEffect(() => {
    fetchGuides();
  }, []);

  return (
    <Container
      style={styles.mainContainer}
    >
      <Title title="Guías de la ruta" />
      <SearchBar setSearch={setSearch}>
        {/* <Button
          variant="contained"
          disabled={!hasItemsSelected}
          startIcon={<UserTag variant="Bold" />}
          onClick={() => handleDialogOpen("AssingUserGuides")}
          sx={hasItemsSelected ? styles.activeButton : styles.inactiveButton}
        >
          Asignar guías
        </Button> */}
      </SearchBar>

      <GuidesDetailsTable guides={guides} search={search} fetchGuides={fetchGuides} isLoading={isLoading} />
      
    </Container>
  );
};

export default GuidesDetails;
